import {
  type Address,
  type AddressStored,
  type CasAddress,
  type CasAddressStored,
  isNonEmptyString,
} from "@jti/fe-common";

export const convertStoredAddressToCasAddress = (
  address: Address
): Omit<CasAddress, "phone"> & { phone: string | null } => {
  return {
    country_code: address.countryCode,
    street: [address.streetName, address.streetNumber, address.streetAdditional],
    phone: isNonEmptyString(address.telephone) ? address.telephone : null,
    post_code: address.postcode,
    city: address.city,
    first_name: address.firstname,
    last_name: address.lastname,
    default_shipping: address.isDefaultShipping ?? false,
    default_billing: address.isDefaultBilling ?? false,
    administrative_area_level_2: address.provinceName || "",
    sublocality_level_2: address.districtName || "",
    district: address.district || "",
    building_number: address.buildingNumber || "",
    neighborhood: address.neighborhood || "",
    landmark: address.landmark || "",
    premise: address.premise || "",
    short_address: address.shortAddress || "",
    ...(address.region && {
      region: address.region,
    }),
  };
};

export const convertStoredAddressToCasAddressStored = (address: AddressStored): CasAddressStored => {
  return {
    ...address,
    street: [address.streetName, address.streetNumber, address.streetAdditional],
    country_id: address.countryCode,
    country_code: address.countryCode,
    default_billing: address.isDefaultBilling ?? false,
    default_shipping: address.isDefaultShipping ?? false,
    administrative_area_level_2: address.provinceName || null,
    sublocality_level_2: address.districtName || null,
    extension_attributes: {
      subscription: address.isSubscription,
    },
    building_number: address.buildingNumber || null,
    district: address.district || null,
    neighborhood: address.neighborhood || null,
    premise: address.premise || null,
    landmark: address.landmark || null,
    region: address.region ?? {
      region_id: 0,
      region_code: null,
      region: null,
    },
  };
};
